// extracted by mini-css-extract-plugin
module.exports = {"root":"Grid--root--3VM-i","item":"Grid--item--1a3bl","gap":"Grid--gap--36gdC","width-2":"Grid--width-2--9WIjw","width-3":"Grid--width-3--2sElO","width-4":"Grid--width-4--9srwj"};